// extracted by mini-css-extract-plugin
module.exports = {"ways":"WayChoice_ways__16lfw","way":"WayChoice_way__2ZMdh","selected":"WayChoice_selected__2XNSY","actions":"WayChoice_actions__5kbxV","header":"WayChoice_header__2R-RO"};